var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { toast } from "react-toastify";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
export var showToast = function (type, message) {
    var Icon = type === "success" ? FaCheckCircle : FaTimesCircle;
    // Detecta mobile via window width
    var isMobile = typeof window !== "undefined" && window.innerWidth < 640;
    var options = {
        icon: Icon({}),
        style: __assign({ backgroundColor: "#1f2937", color: type === "success" ? "#10b981" : "#ef4444" }, (isMobile ? { marginTop: "20px", padding: "0 15px" } : {})),
    };
    if (type === "success") {
        toast.success(message, options);
    }
    else {
        toast.error(message, options);
    }
};
